import { QuestionTypeEnum } from '@/types/schema';

import { QuestionEditorProps, QuizEditField } from '../../../types';
import FTBEditor from '../../FTBEditor';

const FillInTheBlanksEditField: QuizEditField = {
  Editor: (props: QuestionEditorProps) => (
    // when adding any text the key will change from 0 to 1 thus remount. 0 || 1 will not trigger remount
    <FTBEditor key={props.question.ftbComponents?.set.length || 1} {...props} />
  ),
  type: QuestionTypeEnum.FillInTheBlanks,
};

export default FillInTheBlanksEditField;
